import React from "react";
import "./footer.scss";
import "../../App.scss";
// import { Link } from "react-router-dom";

function Footer() {
	return (
		<footer>
			<div className="container footer">
				<div className="footer--inner container--inner">
					<div className="footer--inner--text">
						{`©${new Date().getUTCFullYear() ?? 2024} ArcSpan. All rights reserved.`} {/*<Link to="/cookies">Cookie Notification</Link>,{" "}
						<Link to="/privacy">Privacy</Link> and <Link to="/terms">Terms</Link>*/}
					</div>
					{/* <div className="footer--inner--text contact">
						<Link to="/contact">Contact Us</Link>
					</div> */}
				</div>
			</div>
		</footer>
	);
}

export default Footer;
